import { Component, Input } from '@angular/core';
import { CcsSentryError } from 'src/app/core/store/utils';

@Component({
  selector: 'app-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.scss'],
})
export class ContentContainerComponent {
  @Input() isLoading?: boolean | null = null;
  @Input() error?: CcsSentryError | CcsSentryError[] | null = null;

  constructor() {}
}
